import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { submitOrder } from '@ff-os/pdp-shared-redux/apis/submitOrder';
import { selectIsProductDisabled } from '@ff-os/pdp-shared-redux/slices/sceneSlice';
import { OrderButton } from '@ff-os/shared-react/components/order-button/OrderButton';
import { GiftPdpDispatch, GiftPdpState } from '@ff-scene-plugins/gift-redux/store';
import classNames from 'classnames';
import { selectHasError, selectIsProjectWaitingOnRequests } from '../_redux-project';
import styles from './OrderButton.module.scss';

const _GiftOrderButton = ({
    disabled, className, loading, placeOrder, contentFirst, isProductDisabled
}: Props) => {

    const { t } = useTranslation();

    const onClick = useCallback(async () => {
        if (!disabled) {
            placeOrder();
        }
    }, [disabled, placeOrder]);

    const buttonText = isProductDisabled
        ? t('order_button.temporarily_out_of_stock')
        : t('order_button.text');

    return (
        <OrderButton
            className={classNames(styles.button, className, { [styles.contentFirst]: contentFirst })}
            disabled={disabled}
            loading={loading} onClick={onClick} pluginName='gift'
            contentClassName={contentFirst ? styles.contentFirstContent : undefined}>
            {buttonText}
        </OrderButton>
    );
};

type Props = {
    loading: boolean;
    disabled: boolean;
    isProductDisabled: boolean;
    className?: string;
    placeOrder: () => void;
    contentFirst?: boolean;
};

const mapStateToProps = (state: GiftPdpState) => ({
    loading: selectIsProjectWaitingOnRequests(state),
    disabled: selectDisabled(state),
    isProductDisabled: selectIsProductDisabled(state)
});

const mapDispatchToProps = (dispatch: GiftPdpDispatch, ownProps: { quantity?: number }) => ({
    placeOrder: () => dispatch(submitOrder(ownProps.quantity))
});

export const GiftOrderButton = connect(
    mapStateToProps,
    mapDispatchToProps
)(_GiftOrderButton);

const selectDisabled = createSelector([
    selectHasError, selectIsProjectWaitingOnRequests, selectIsProductDisabled
], (hasError, loading, isProductDisabled) => hasError || loading || isProductDisabled);